module.exports = "4ed093ab7ced8206b6564afe9cd49c50.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/cut.png
// module id = 14
// module chunks = 0